const ROLES = {
	super_admin: "SUPER ADMIN",
	admin: "ADMIN",
	store_admin: "STORE ADMIN",
	doctor: "DOCTOR",
	lab: "LAB",
	// Read only role pinned to a single store. Sees that store's scan list and
	// nothing else - no customers, no dashboard, no settings.
	user: "USER"
};

export default ROLES;
